import React from "react";
import { useTranslation } from "react-i18next";

import { AssistantHeader, FlexWrapper, HeaderDivider } from "./../AdAssistant.styled";

import { AllViewBtn, SingleViewBtn } from "./AdAssistantHeader.styled";
import { VIEW_SELECTOR } from "../constants";
import Switch from "../../../Components/switch/Switch";
import PreviewPlacements from "../preview-placements/PreviewPlacements";
import { NumberCounter } from "../../../Components/number-counter/NumberCounter";

const AdAssistantHeader = ({
  viewSelected,
  emitViewChange,
  isAllVariants,
  isShowUseSelected,
  isShowDismissSelected,
  setUseSelected,
  setDismissSelected,
  adIndexCount,
  totalAds,
  // Orientation
  orientationsOptions,
  orientationSelected,
  handleOrientationChange
}) => {
  const { t } = useTranslation();

  return (
    <AssistantHeader>
      <FlexWrapper gap={12} justify={"space-between"} width={"100%"}>
        <FlexWrapper gap={12} justify={"flex-start"}>
          <SingleViewBtn
            $isSelected={viewSelected === VIEW_SELECTOR.SINGLE}
            onClick={() => emitViewChange(VIEW_SELECTOR.SINGLE)}
          >
            {t("Single")}
            <NumberCounter
              currentIdx={adIndexCount}
              total={totalAds}
              isSingle={viewSelected === VIEW_SELECTOR.SINGLE}
            />
          </SingleViewBtn>
          <AllViewBtn
            $isSelected={viewSelected === VIEW_SELECTOR.ALL_DRAFTS}
            onClick={() => emitViewChange(VIEW_SELECTOR.ALL_DRAFTS)}
          >
            {t("All drafts")}
          </AllViewBtn>
        </FlexWrapper>
        {isAllVariants && (
          <FlexWrapper gap={12} justify={"flex-end"}>
            <Switch
              isCheck={isShowUseSelected}
              setCheck={setUseSelected}
              leftLabel={t("Show selection")}
            />
            <Switch
              isCheck={isShowDismissSelected}
              setCheck={setDismissSelected}
              leftLabel={t("Show dismissed")}
            />
          </FlexWrapper>
        )}
      </FlexWrapper>
      {isAllVariants && <HeaderDivider />}
      <FlexWrapper justify={"flex-start"} width={"max-content"}>
        <PreviewPlacements
          orientationsOptions={orientationsOptions}
          orientationSelected={orientationSelected}
          handleOrientationChange={handleOrientationChange}
        />
      </FlexWrapper>
    </AssistantHeader>
  );
};

export default AdAssistantHeader;
